import { getThumbnail, QUAM_QUOTE_COOKIE_KEY } from "../../Helpers";
import { useCookies } from "react-cookie";

export default function QuoteRow({ product }) {
  const [cookies, setCookie] = useCookies([QUAM_QUOTE_COOKIE_KEY]);

  // Read the active quote state directly from the cookie object
  const currentQuotes = cookies[QUAM_QUOTE_COOKIE_KEY] || {};
  const isProductInQuote = !!currentQuotes[product.id];

  // Deriving quantity directly from the cookie object (fallback to 1 if not added yet)
  const productQty = currentQuotes[product.id]?.quantity || 1;
  const productVersion = currentQuotes[product.id]?.version;

  const prodImage = getThumbnail(product);

  // Helper function to handle updating the cookie map directly
  const updateCookieQuantity = (newQty) => {
    const newQuotes = {
      ...currentQuotes,
      [product.id]: {
        title: product.title,
        url: `${window.location.origin}/product/${product.name}`,
        ...currentQuotes[product.id], // preserve existing data if it exists
        quantity: parseInt(newQty),
      },
    };
    setCookie(QUAM_QUOTE_COOKIE_KEY, newQuotes, { path: "/" });
  };

  const increaseQty = (e) => {
    e.preventDefault();
    e.stopPropagation();
    updateCookieQuantity(productQty + 1);
  };

  const decreaseQty = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (productQty <= 1) return;
    updateCookieQuantity(productQty - 1);
  };

  const handleToggleQuote = (e, shouldAddToQuote) => {
    e.preventDefault();
    e.stopPropagation();

    if (shouldAddToQuote) {
      updateCookieQuantity(productQty);
    } else {
      // remove from quote
      const newQuotes = { ...currentQuotes };
      delete newQuotes[product.id];
      setCookie(QUAM_QUOTE_COOKIE_KEY, newQuotes, { path: "/" });
    }
  };

  return (
    <div
      key={product.id}
      className="flex flex-col md:flex-row items-center border border-[#D3D3D5] mb-2 p-4 md:p-0"
    >
      {prodImage && (
        <img src={prodImage} alt={product.name} className="w-60 md:mr-16" />
      )}
      <div className="w-full md:w-2/5 md:mr-32">
        <h3 className="font-primary text-2xl font-bold mb-4">{product.name}</h3>
        {productVersion && (
          <p className="text-base mt-0 mb-2 font-semibold">Version: {productVersion}</p>
        )}
        <p className="text-base mt-0 mb-2">
          {product.sections?.product_details?.short_description}
        </p>
      </div>
      <div className="flex flex-col gap-5">
        <div className="text-center text-lg">Quantity</div>
        <div className="text-lg font-bold inline-flex gap-2 justify-between border border-[#A6A8AB] rounded-sm py-4 px-4 min-w-40">
          <button
            className="w-8 h-8 cursor-pointer text-4xl"
            onClick={(e) => decreaseQty(e)}
          >
            -
          </button>
          <input
            type="text"
            className="w-12 text-center text-4xl"
            value={productQty}
            name="quantity"
            onChange={(e) => updateCookieQuantity(e.target.value)}
          />
          <button
            className="w-8 h-8 cursor-pointer text-4xl"
            onClick={(e) => increaseQty(e)}
          >
            +
          </button>
        </div>

        {/* Conditional rendering depending on whether it's in the cookie map */}
        <button
          className="text-lg cursor-pointer"
          onClick={(e) => handleToggleQuote(e, !isProductInQuote)}
        >
          <span className="w-4 h-4 inline-flex items-center justify-center rounded-full border border-black text-lg mr-1">
            {isProductInQuote ? "x" : "+"}
          </span>{" "}
          {isProductInQuote ? "Remove" : "Add to Quote"}
        </button>
      </div>
    </div>
  );
}
